"use strict";

var FlexSearch = require('flexsearch/dist/flexsearch.es5');
var indexOpts = {
  doc: {
    id: 'id',
    field: 'title'
  }
};
function StyleFilter(listStyles) {
  this._listStyles = listStyles;
}
StyleFilter.prototype = {
  _listAll: function _listAll() {
    var _this = this;
    if (this._listAll.promise) {
      return this._listAll.promise;
    }
    return this._listAll.promise = new Promise(function (resolve, reject) {
      _this._listStyles().then(resolve).catch(function (error) {
        _this._listAll.promise = null;
        reject(error);
      });
    });
  },
  _buildIndex: function _buildIndex(styles) {
    if (this._buildIndex.promise) {
      return this._buildIndex.promise;
    }
    return this._buildIndex.promise = new Promise(function (resolve) {
      setTimeout(function () {
        var index = new FlexSearch(indexOpts);
        index.add(styles);
        resolve(index);
      }, 0);
    });
  },
  // PUBLIC
  preload: function preload() {
    return this._listAll();
  },
  filter: function filter() {
    var _this2 = this;
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$term = params.term,
      term = _params$term === void 0 ? '' : _params$term,
      _params$page = params.page,
      page = _params$page === void 0 ? 1 : _params$page,
      _params$size = params.size,
      size = _params$size === void 0 ? 30 : _params$size;
    return this._listAll().then(function (styles) {
      return _this2._buildIndex(styles).then(function (index) {
        var begin = (page - 1) * size;
        var end = begin + size;
        var matched = term ? index.search(term) : styles;
        var more = end <= matched.length;
        return {
          more: more,
          results: matched.slice(begin, end)
        };
      });
    });
  }
};
module.exports = StyleFilter;
